import {
  GET_QUESTIONS_LIST_FAIL,
  GET_QUESTIONS_LIST_REQUEST,
  GET_QUESTIONS_LIST_SUCCESS,
  QUESTION_DETAILS_FAIL,
  QUESTION_DETAILS_REQUEST,
  QUESTION_DETAILS_RESET,
  QUESTION_DETAILS_SUCCESS,
  QUESTION_VERIFY_FAIL,
  QUESTION_VERIFY_REQUEST,
  QUESTION_VERIFY_SUCCESS,
  EXTRACT_QUESTION_PDF_FAIL,
  EXTRACT_QUESTION_PDF_REQUEST,
  EXTRACT_QUESTION_PDF_SUCCESS,
  EXTRACT_QUESTION_PDF_RESET,
  BULK_CREATE_MCQ_FAIL,
  BULK_CREATE_MCQ_REQUEST,
  BULK_CREATE_MCQ_SUCCESS,
  BULK_CREATE_MCQ_RESET,
} from "../../Constants/QuestionVerifyConstants";

const initialStateDefault = {
  status: false,
  data: null,
  loading: null,
  error: null,
};

export const QuestionListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_QUESTIONS_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_QUESTIONS_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_QUESTIONS_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const QuestionDetailsReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === QUESTION_DETAILS_REQUEST) {
      return {
        ...state,
        loading: true,
        data: null,
      };
    }

    if (action.type === QUESTION_DETAILS_RESET) {
      return {
        ...initialStateDefault,
      };
    }

    if (action.type === QUESTION_DETAILS_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === QUESTION_DETAILS_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const QuestionVerifyReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === QUESTION_VERIFY_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === QUESTION_VERIFY_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === QUESTION_VERIFY_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const ExtractQuestionPdfReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === EXTRACT_QUESTION_PDF_REQUEST) {
      return {
        ...state,
        status: false,
        loading: true,
      };
    }

    if (action.type === EXTRACT_QUESTION_PDF_RESET) {
      return {
        ...initialStateDefault,
      };
    }

    if (action.type === EXTRACT_QUESTION_PDF_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === EXTRACT_QUESTION_PDF_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const BulkCreateMCQReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === BULK_CREATE_MCQ_REQUEST) {
      return {
        ...state,
        status: false,
        loading: true,
      };
    }

    if (action.type === BULK_CREATE_MCQ_RESET) {
      return {
        ...initialStateDefault,
      };
    }

    if (action.type === BULK_CREATE_MCQ_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === BULK_CREATE_MCQ_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

